import NewLayout from "@components/new-ui/Layout";
import React from "react";
import { CasestudyCard, CasestudyCardProps } from ".";
import {
    CaseStudySubInformation,
    CaseStudyHerosection,
    CaseStudyInformation,
    ClientFeedback,
    FeatureList,
    Navbar,
    navLinks,
    OrganizationProfile,
} from "./alrannan-administrative-services";
import StatsInfo from "@components/new-ui/IndustriesSection/StatsInfo";

const casestudyCardsDetails: CasestudyCardProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/alrannan-admin-service.png",
        title: "Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/alrannan-administrative-services",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/goireland.png",
        title: "Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/goireland",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/dubai-housekeeping.png",
        title: "Gallabox transforms Dubai Housekeeping's journey to service excellence on WhatsApp",
        sector: "Service",
        externalLink: "/case-study/dubai-housekeeping",
    },
];
const footprintRealEstate: React.FC = () => {
    return (
        <NewLayout
            title="Footprint Real Estate | WhatsApp Business customer story"
            description="Find out how Footprint Real Estate transformed their WhatsApp lead engagement using Gallabox's innovative features, achieving exceptional growth in conversions and customer acquisition."
            canonical="https://gallabox.com/case-study/footprint-real-estate"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/case-study/footprint-real-estate-og.png" }}
        >
            <CaseStudyHerosection
                title="Gallabox revolutionizes lead engagement for Footprint Real Estate"
                description="Find out how Footprint Real Estate transformed their WhatsApp lead engagement and customer communication using Gallabox's innovative features, achieving exceptional growth in conversions and customer acquisition."
                imageUrl={"https://assets.gallabox.com/gb-home/case-study/footprint-real-estate.png"}
                redirectUrl={"/case-study"}
            />

            <StatsInfo
                statsInfo={[
                    { percentage: "150%", label: "Growth in first-time customer conversion" },
                    { percentage: "100%", label: "Increase in lead generation" },
                    { percentage: "100%", label: "Expansion in customer base" },
                ]}
            />

            <section className="max-w-6xl mx-auto  md:grid md:grid-cols-6 mt-24 mb-24">
                <div className="bg-white col-span-1">
                    <div style={{ position: "sticky", top: "100px" }}>
                        <OrganizationProfile
                            companyProfileData={[
                                { label: "Company", value: ["Footprint Real Estate"] },
                                { label: "Industry", value: ["Real Estate"] },
                                { label: "Employees", value: ["51-200"] },
                                { label: "Team", value: ["Sales", "Support", "Marketing"] },
                            ]}
                            product={{
                                title: "Features used",
                                productLink: [
                                    { link: "https://gallabox.com/whatsapp-flows", label: "WhatsApp Flows" },
                                    { link: "https://gallabox.com/whatsapp-chatbot", label: "WhatsApp Chatbot" },
                                    { link: "https://gallabox.com/whatsapp-flows", label: "WhatsApp Broadcast" },
                                    { link: "https://gallabox.com/click-to-whatsapp-ads", label: "Click-to-WhatsApp Ads" },
                                ],
                            }}
                        />
                    </div>
                </div>
                <div className=" col-span-4 md:pl-8 px-4">
                    <div className="flex flex-col">
                        <section id="About">
                            <CaseStudyInformation mainTitle={"Where real estate meets real-time engagement"} />

                            <p className="text-gray-900 text-base mb-5">
                                <a href="https://fpproperty.com" className="text-blue-500">
                                    Footprint Real Estate&nbsp;
                                </a>
                                is an award-winning real estate company based in Dubai. But with a high reputation comes growth pains as they set out to revolutionize how they
                                connect with potential property buyers and sellers at scale. They needed a solution that could capture and engage leads at their most responsive
                                moments on WhatsApp.
                            </p>
                        </section>

                        <section id="Challenges">
                            <CaseStudyInformation
                                subTitle={"Managing communication on basic WhatsApp wasn't sustainable"}
                                descriptions={["Before Gallabox, Footprint Real Estate faced several challenges:"]}
                                className="gap-4"
                            />

                            <FeatureList
                                List={[
                                    { listItem: "Individual team members managing separate WhatsApp accounts" },
                                    { listItem: "Frequent account suspensions disrupting communication" },
                                    { listItem: "Limited client engagement capabilities" },
                                    { listItem: "Inconsistent follow-up processes." },
                                ]}
                                className="mt-5 bg-gray-100 mb-10"
                            />
                            <p className="text-gray-900 text-base mb-5">
                                &quot;Prior to implementing Gallabox, each team member managed client interactions manually through their individual WhatsApp accounts. This
                                approach resulted in account suspensions and limited engagement with our clients,&quot; explains Avinash Babu, Assistant Digital Marketing Manager
                                at Footprint Real Estate.
                            </p>
                        </section>

                        <section id="Solutions">
                            <CaseStudyInformation
                                subTitle={"Why Gallabox became the clear choice"}
                                descriptions={["After exploring various tools and free trials, Footprint Real Estate chose Gallabox for several compelling reasons:"]}
                                className="gap-4"
                            />

                            <FeatureList
                                List={[
                                    { listItem: "Simple and intuitive user interface" },
                                    { listItem: "Unified platform for all communications" },
                                    { listItem: "Advanced sequencing capabilities" },
                                    { listItem: "Powerful bot functionality" },
                                    { listItem: "Effective Click-to-WhatsApp features." },
                                ]}
                                className="mt-5 bg-gray-100 mb-10"
                            />

                            <ClientFeedback
                                descriptions="Gallabox stood out for its simplicity and ease of use. Its intuitive user interface and the ability to manage everything seamlessly from a single platform made it the ideal solution."
                                authorName="Avinash Babu"
                                designationWithServiceName="Assistant Digital Marketing Manager, Footprint Real Estate"
                                className="border-blue-700 bg-gray-100"
                            />

                            <CaseStudyInformation
                                subTitle={"Transforming real estate communication"}
                                descriptions={["Footprint Real Estate leveraged multiple Gallabox features to revolutionize their client engagement:"]}
                                className="gap-4"
                            />

                            <CaseStudySubInformation
                                content={[
                                    {
                                        title: "Strategic broadcast messaging",
                                        description: [
                                            "They implemented targeted broadcast campaigns to reach potential buyers and sellers with relevant property listings and market updates.",
                                        ],
                                    },
                                    {
                                        title: "Automated engagement with chatbots",
                                        description: [
                                            "The team deployed smart chatbots  to handle initial property inquiries, qualify leads, and provide instant information about listings.",
                                        ],
                                    },
                                    {
                                        title: "Structured communication flows",
                                        description: [
                                            "The real estate firm created custom flows to nurture leads through the property-buying journey, ensuring consistent follow-up and engagement.",
                                        ],
                                    },
                                    {
                                        title: "Click-to-WhatsApp for instant connections",
                                        description: [
                                            "They utilized Click-to-WhatsApp ads to convert social media interest into direct conversations, capturing leads at their peak interest.",
                                        ],
                                    },
                                ]}
                                className="my-6"
                            />

                            <ClientFeedback
                                descriptions="Gallabox provides innovative features that streamline our WhatsApp follow-ups, including sequencing, bots, and Click-to-WhatsApp (CTWA) capabilities—all of which have proven highly effective in our testing. "
                                authorName="Avinash Babu"
                                designationWithServiceName="Assistant Digital Marketing Manager, Footprint Real Estate"
                                className="border-blue-700 bg-gray-100"
                            />
                        </section>

                        <section id="Impact">
                            <CaseStudyInformation
                                subTitle={"The numbers tell a success story"}
                                descriptions={["The implementation of Gallabox brought remarkable improvements:"]}
                                className="gap-6"
                            />
                            <p className="text-gray-900 text-base my-5">150% growth in first-time customer conversion</p>

                            <FeatureList
                                List={[{ listItem: "Better lead qualification" }, { listItem: "Faster response times" }, { listItem: "More effective follow-ups." }]}
                                className="mt-5 bg-gray-100 mb-10"
                            />

                            <p className="text-gray-900 text-base my-5">100% increase in lead generation</p>

                            <FeatureList
                                List={[
                                    { listItem: "Expanded reach through WhatsApp campaigns" },
                                    { listItem: "Improved lead capture mechanisms" },
                                    { listItem: "Enhanced targeting capabilities." },
                                ]}
                                className="mt-5 bg-gray-100 mb-10"
                            />

                            <p className="text-gray-900 text-base my-5 ">100% growth in customer base</p>

                            <FeatureList
                                List={[{ listItem: "Better customer engagement" }, { listItem: "Streamlined communication" }, { listItem: "Improved service delivery." }]}
                                className="mt-5 bg-gray-100 mb-10"
                            />

                            <CaseStudyInformation
                                subTitle={"Building on success"}
                                descriptions={["With Gallabox as their WhatsApp Business API provider, Footprint Real Estate continues to:"]}
                                className="gap-4"
                            />

                            <FeatureList
                                List={[
                                    { listItem: "Generate and nurture quality leads" },
                                    { listItem: "Streamline property showcasing" },
                                    { listItem: "Improve customer retention" },
                                    { listItem: "Boost cross-selling opportunities" },
                                    { listItem: "Automate support processes" },
                                    { listItem: "Close deals more efficiently" },
                                ]}
                                className="mt-5 bg-gray-100 mb-10"
                            />

                            <p className="text-gray-900 text-base mb-5">
                                Footprint Real Estate has transformed not just their client communication but their entire approach to real estate marketing through effective use
                                of Gallabox’s WhatsApp Business automation.
                            </p>
                        </section>
                    </div>
                </div>
                <div>
                    <div style={{ position: "sticky", top: "100px", minHeight: "510px" }} className="hidden md:block">
                        <Navbar links={navLinks} />
                    </div>
                </div>
            </section>
            <section className="max-w-6xl mx-auto text-center md:text-left">
                <div>
                    <h3 className="text-gray-900 max-w-6xl mx-auto mb-10 mt-5 text-center md:text-left">Keep exploring stories like this.</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-10 mb-20">
                        {casestudyCardsDetails.map((data, index) => (
                            <CasestudyCard key={index} {...data} />
                        ))}
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default footprintRealEstate;
